import { LDate } from '@/app';
import { __const } from '@/app/_internal/helpers';

export class LStorage {

    static readonly VERSION = () => __const('VITE_TS_STORAGE_VERSION'); // Cambia este valor para invalidar el localStorage
    static readonly VERSION_KEY = 'config-version';

    static setItem(key: string, value: string) {
        window.localStorage.setItem(key, value);
    }

    static getItem(key: string) {
        return window.localStorage.getItem(key);
    }

    static removeItem(key: string) {
        window.localStorage.removeItem(key);
    }

    static exist(key: string) {
        return LStorage.getItem(key) !== null;
    }

    static checkAndUpdateVersion() {
        const savedVersion = localStorage.getItem(this.VERSION_KEY);
        if (savedVersion !== this.VERSION()) {
            localStorage.clear();
            localStorage.setItem(this.VERSION_KEY, this.VERSION());
        }
    }


    static isFirstConnectionInDay() {
        const validSecondsToBeCountedAsTheSameDay = 10;
        const lastConn = LStorage.getItem('lastConnection');
        const diffNow = LDate.diffNow(lastConn, 'seconds');
        return (
            !LStorage.exist('lastConnection')
            ||
            !LDate.hasSame(LDate.now(), lastConn, 'day')
            ||
            (Math.abs(diffNow ?? 0) < validSecondsToBeCountedAsTheSameDay)
        );
    }

    static setNowAsLastConnection() {
        LStorage.setItem('lastConnection', LDate.toSeconds(LDate.now()));
    }

}
